module.exports = __webpack_public_path__ + "img/14 - Condominio_das_Americas_VistaParque.2600e4e0.jpg";